const BANNER_FIRST_SETUP_DONE_PREFIX = 'kb_first_setup_done_';
const BANNER_DISMISSED_PREFIX = 'kb_banner_dismissed_';

// Keyed by the house PUBLIC id (a stable, random, non-reused string), NOT the numeric id. localStorage
// outlives the database, and a local DB reinstall restarts autoincrement ids — so keying by numeric id
// would let a brand-new house inherit a previous house's stale banner state. public_id never collides.

/**
 * Called once during onboarding finalization to mark this house as first-time setup complete.
 * Used by KnowledgeBaseBanner to decide whether to show the banner.
 */
export const markKbFirstSetupDone = (housePublicId: string): void => {
	localStorage.setItem(`${BANNER_FIRST_SETUP_DONE_PREFIX}${housePublicId}`, 'true');
};

export const kbFirstSetupDoneKey = (housePublicId: string) => `${BANNER_FIRST_SETUP_DONE_PREFIX}${housePublicId}`;
export const kbBannerDismissedKey = (housePublicId: string) => `${BANNER_DISMISSED_PREFIX}${housePublicId}`;
